<ng-container *ngIf="authError$ | async">
    <div class="sso-page">
        <div class="unauthorized-error" *ngIf="unauthorizedUser">
            <div class="container">
                <div class="unauth-img"></div>
                <h1>{{ "userData.requestAccess" | cxTranslate }}</h1>
                <p>{{ "userData.infoDontExist" | cxTranslate }}
                <br>{{ "userData.clickOn" | cxTranslate }} <a href="#">{{ "userData.registerBtn" | cxTranslate }}</a>{{ "userData.forAccess" | cxTranslate }} 
                </p>
            </div>
        </div>

        <div class="unauthorized-error" *ngIf="disabledUser">
            <div class="container">
                <div class="unauth-img"></div>
                <h1>{{ "userData.accDisable" | cxTranslate }}</h1>
                <p>{{ "userData.accDisable2" | cxTranslate }}
                <br>{{ "userData.speakToService" | cxTranslate }}<a href="#">{{ "userData.registerBtn" | cxTranslate }}</a> {{ "userData.again" | cxTranslate }}.
                </p>
            </div>
        </div>
    </div>
</ng-container>